export enum TooltipVariant {
    Default = 'default',
    Alt = 'alt'
}
